import instance from "@/utils/require.js"

export function apiProductBatteryAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/product_battery/add",
		method: "post",
		data
	})
}
export function apiProductBatteryUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/product_battery/update",
		method: "post",
		data
	})
}

export function apiProductBatterySearch(data = {}) {
	return instance({
		url: "/aim/api/v3/product_battery/search",
		method: "post",
		data
	})
}

export function apiProductBatteryEnable(data = {}) {
	return instance({
		url: "/aim/api/v3/product_battery/enable",
		method: "post",
		data
	})
}

export function apiProductBatteryDisable(data = {}) {
	return instance({
		url: "/aim/api/v3/product_battery/disable",
		method: "post",
		data
	})
}

export function apiProductBatteryCapacityList(data = {}) {
	return instance({
		url: "/aim/api/v3/product_battery/capacity_list",
		method: "post",
		data
	})
}

export function apiProductBatteryVersionList(data = {}) {
	return instance({
		url: "/aim/api/v3/product_battery/version_list",
		method: "post",
		data
	})
}